<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block my-loan" v-loading="Loading">
      <div class="top-title">通知中心</div>
      <div class="tabless">
        <el-collapse accordion @change="handleChange">
          <el-collapse-item v-for="(item) in list" :key="item.id" :name="item.id">
            <template slot="title">
              <div class="titles">
                <div class="a" :class="{isread : item.isRead != 1}">{{item.noticeTitle}}</div>
                <div class="b">
                  <span v-if="item.isRead == 1" class="reads">已读</span>
                  <span v-else class="isreads">未读</span>
                  {{formatterTime(item.createDate)}}
                </div>
              </div>
            </template>
            <div class="tb-row" @click="toDetail(item.skipUrl)">
              <span>{{ item.noticeMessage }}</span>
              <span class="detail" v-if="item.skipUrl">详情</span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-pagination style="text-align: center;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="search.pageNumber" :page-size="search.pageSize" layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFtt2 } from '@/utils/timeFormat';
import HeaderImg from '@/components/HeaderImg';
export default {
  components: {
    HeaderImg,
  },
  data() {
    return {
      search: {
        pageNumber: 1,
        pageSize: 10,
        userId: this.$store.state.userInfo.id,
        type: 3,
      },
      userInfo: {},
      list: [],
      total: 0,
      headerList: [{ name: '首页', path: '/Home' }, { name: '通知中心' }],
      Loading: false,
      comment: false,
    };
  },
  methods: {
    formatterTime(row) {
      if (row) {
        return dateFtt2('YYYY-mm-dd HH:MM:SS', row);
      } else {
        return '--';
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.search.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.search.pageNumber = val;
      this.getDataList();
    },
    handleChange(val) {
      if (val) {
        this.Loading = true;
        this.$api.user
          .noticeDoneReadDetail({ id: val })
          .then((res) => {
            if (res.code == 1000) {
              this.list.forEach((item) => {
                if (item.id == val) {
                  item.isRead = 1;
                }
              });
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((error) => {})
          .finally(() => {
            this.Loading = false;
          });
      }
    },
    getDataList() {
      this.Loading = true;
      this.$api.user
        .noticeList(this.search)
        .then((res) => {
          if (res.code == 1000) {
            this.list = res.data;
            this.total = res.total;
            let read = res.data.filter((item) => item.isRead != 1);
            if (read.length > 0) {
              this.comment = true;
            }
            this.$store.dispatch('cnoticeCenter', this.comment);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.Loading = false;
        });
    },
    toDetail(url) {
      if (!url) return
      let data = JSON.parse(url)
      if (data.code === 1) {
        this.$goTo("InfoCollection");
      }
      if (data.code === 2) {
        this.$goTo("MyLoan");
      }
    }
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style lang="scss" >
.tabless {
  .el-collapse-item__header {
    height: 70px !important;
  }
}
</style>
<style lang="scss" scoped>
.top-title {
  height: 56px;
  line-height: 56px;
  width: 1064px;
  margin: auto;
  color: #fff;
  background-image: linear-gradient(-135deg, #55607b 0%, #394259 100%);
  padding-left: 40px;
}
.top-title::before {
  content: ' ';
  width: 20px;
  height: 20px;
  background: url('~@/assets/icon/notices.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 15px;
  top: 20px;
}
.my-loan {
  // margin: 0 48px;
  /deep/ .el-form-item {
    margin-right: 18px;
  }
  .tabless {
    width: 1064px;
    margin: auto;
    .titles {
      font-size: 16px;
      .reads {
        color: #aeaeae;
        background: rgba(122, 122, 122, 0.06);
        border: 1px solid #aeaeae;
      }
      .isreads {
        color: #fc6937;
        background: rgba(240, 118, 74, 0.12);
        border: 1px solid #fc6937;
      }
      .a {
        font-weight: 600;
        line-height: 1;
        font-size: 18px;
        color: #666666;
        padding-bottom: 5px;
      }

      .isread::before {
        content: '';
        width: 5px;
        height: 5px;
        background: #fff;
        border: 2px solid #fc6937;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
      .b {
        padding-top: 5px;
        line-height: 1;
        font-size: 14px;
        color: #999999;
        span:first-child {
          width: 37px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          display: inline-block;
          font-size: 11px;
          margin-right: 15px;
        }
      }
    }
    .tb-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      .detail {
        color: #999;
        margin-left: 10px;
      }
    }
  }
}
</style>